import {
  UserInfo,
  QrCodeLoginResponse,
  QrCodeLoginRequest,
  OTPTransactionRequest,
} from "./../interfaces/auth-user-info";
import { SmsLog } from "./../interfaces/sms-log";
import { menuLoginPhone } from "./../../../config/config";
import { Injectable, NgZone } from "@angular/core";
import { ApiService } from "app/shared/services/api.service";
import {
  Config,
  menuRegister,
  menuLoginOtp,
  chilPath,
} from "app/config/config";
import { AppConsts } from "app/shared/consts/app-consts";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { AuthUserInfo } from "../interfaces/auth-user-info";
import { map } from "rxjs/operators";
import { AngularFireAuth } from "@angular/fire/auth";
import { Router } from "@angular/router";
// import { User } from "firebase";
import { RequestLogin, AgeRangeItem } from "../interfaces/request-login";
import { environment } from "environments/environment";
import { RegisterFormData } from "./../interfaces/signup-form-data";
import { MechanicService } from "app/shared/services/mechanic/mechanic.service";
import { MasterItem } from "app/shared/interfaces/master-model";
import { AppMessages } from "app/shared/consts/app-messages";
import { OTPInfo } from "app/shared/interfaces/request-login";
import { QrInfoUser } from "app/shared/interfaces/authUserInfo";
declare const window: any;
@Injectable({
  providedIn: "root",
})
export class CustomerAuthService {
  public phoneNumber: string;
  public errorMore: string = "";
  private currentUserSubject: BehaviorSubject<AuthUserInfo>;
  public currentUser: Observable<AuthUserInfo>;
  public registerFormData: RegisterFormData;
  private smsLog: SmsLog;
  public OTPInfo: OTPInfo;

  constructor(
    private apiService: ApiService,
    private mechanicService: MechanicService,
    public afAuth: AngularFireAuth,
    public ngZone: NgZone,
    public router: Router
  ) {
    this.currentUserSubject = new BehaviorSubject<AuthUserInfo>(
      JSON.parse(localStorage.getItem(AppConsts.currentCustomerKey))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): AuthUserInfo {
    return this.currentUserSubject.value;
  }

  public async getUserByPhone(phone: string): Promise<string> {
    var userInfo = await this.apiService
      .get<UserInfo>(
        `${Config.unileverApiPath.getUserByPhone}?PhoneNumber=${phone}`
      )
      .toPromise();
    if (userInfo) {
      const tmpUser: AuthUserInfo = {
        displayName: userInfo.name,
        authToken: "",
        firebaseToken: "",
        uid: userInfo.userId,
        phoneNumber: userInfo.phoneNumber,
        shoperId: userInfo.uid,
      };
      localStorage.setItem(
        AppConsts.currentCustomerKey,
        JSON.stringify(tmpUser)
      );
      this.currentUserSubject.next(tmpUser);

      // Top UI config
      var uiConfig = this.mechanicService.topUIConfig;
      var userInfoShow = uiConfig ? uiConfig.userInfoAlwaysShow : false;
      var lockEditInfo = uiConfig ? uiConfig.lockEditInfo : false;
      var showCity = uiConfig ? uiConfig.showCity : false;
      var showSkinCare = uiConfig ? uiConfig.showSkinCare : false;
      var showSurvey = JSON.parse(
        localStorage.getItem(AppConsts.topUIConfig)
      )?.showSurvey;
      if (
        lockEditInfo &&
        ((showCity && !userInfo.communeId) ||
          (showSkinCare && !userInfo.skinCareId))
      ) {
        return AppMessages.PHONE_NOT_EXITS;
      }

      if (userInfoShow) {
        this.router.navigate([`${menuLoginPhone.path}/${chilPath.register}`], {
          state: {
            backUrl: `${menuLoginPhone.path}//${chilPath.loginPhoneSkipVerify}`,
          },
        });
      } else {
        if (showSurvey) {
          this.router.navigate([
            `${menuLoginPhone.path}/${chilPath.surveyUser}`,
          ]);
        } else {
          this.router.navigate([
            `${menuLoginPhone.path}/${chilPath.customerInforSuccess}`,
          ]);
        }
      }
    }
  }

  signin(phone: string) {
    return this.requestOTP(phone);
  }

  signInupVerify(phone: string, otpCode: string) {
    try {
      this.smsLog.content = otpCode;
      return this.verifyOTP(phone, otpCode).pipe(
        map((result) => {
          this.fireBaseAuth(result["token"].accessToken, phone);
        })
      );
    } catch (error) {
      window.UTopSDK.Tracking.logEvent(
        "tracking",
        { "errorSignInupVerify": error }
      );
    }

  }

  signup(phone: string) {
    return this.requestOTP(phone);
  }

  resendOTP(phone: string) {
    return this.requestOTP(phone);
  }

  checkPhoneRegistered(phone: string) {
    const getUrl = `${Config.unileverApiPath.checkPhoneRegistered}?PhoneNumber=${phone}`;
    return this.apiService.get(getUrl, environment.apiQuatangunilever);
  }

  saveGiveGiftTicket(postData: any) {
    return this.apiService.post(
      `${Config.unileverApiPath.saveGiveGiftTicket}`,
      postData
    );
  }

  logout(): void {
    localStorage.clear();
    this.afAuth.signOut();
    this.currentUserSubject.next(null);
  }

  refreshToken() {
    const tmpUser: AuthUserInfo = JSON.parse(
      localStorage.getItem(AppConsts.currentCustomerKey)
    );
    return this.afAuth.idToken.pipe(
      map((authenToken) => {
        if (authenToken) {
          tmpUser.authToken = authenToken;
          this.updateUserData(tmpUser);
        }
        return authenToken;
      })
    );
  }

  private updateUserData(tmpUser: AuthUserInfo) {
    localStorage.setItem(AppConsts.currentCustomerKey, JSON.stringify(tmpUser));
    this.currentUserSubject.next(tmpUser);
  }

  private fireBaseAuth(firebaseToken: string, phone: string) {
    this.afAuth
      .signInWithCustomToken(firebaseToken)
      .then((result) => {
        try {
          this.firebaseLogger({ status: "signInWithCustomTokenResult", phone: phone, signInWithCustomTokenResult: JSON.stringify(result) }).subscribe();
          localStorage.setItem("refresh_token", result.user.refreshToken);
          result.user.getIdToken(false).then((authToken) => {
            this.setUserData(result.user, authToken, firebaseToken);
            this.requestLogin<RequestLogin>(result.user.uid, phone).subscribe(
              (requestLoginRs) => {
                this.setShoperId(requestLoginRs.uid);
                window.UTopSDK.Tracking.setUserId(requestLoginRs.memberCode);
                this.smsLog.refId = result.user.uid;
                // this.requestSmsLog(
                //   requestLoginRs.isFirstLogin ? "ShoperOTPRegister" : "ShoperOTP"
                // );
                // Top UI config
                var uiConfig = this.mechanicService.topUIConfig;
                var userInfoShow = uiConfig ? uiConfig.userInfoAlwaysShow : false;
                var showSurvey = JSON.parse(
                  localStorage.getItem(AppConsts.topUIConfig)
                )?.showSurvey;

                if (
                  requestLoginRs.isFirstLogin ||
                  requestLoginRs.needUpdate ||
                  userInfoShow
                ) {
                  this.router.navigate([
                    `${menuLoginPhone.path}/${chilPath.register}`,
                  ]);
                } else {
                  this.router.navigate([
                    `${menuLoginPhone.path}/${chilPath.register}`,
                  ]);
                  // if (showSurvey) {
                  //   this.router.navigate([`${menuLoginPhone.path}/${chilPath.surveyUser}`]);
                  //  }else{
                  //   this.router.navigate([`${menuLoginPhone.path}/${chilPath.customerInforSuccess}`]);
                  //  }
                }
              },
              (error) => {
                window.UTopSDK.Tracking.logEvent(
                  "tracking",
                  { "errorRequestLogin": error }
                );
              }
            );
          }).catch(error => {
            this.firebaseLogger({ status: "getIdTokenError", signInWithCustomTokenResult: JSON.stringify(result), error: JSON.stringify(error), phone: phone }).subscribe();
          });
        } catch (error) {
          this.firebaseLogger({ status: "signInWithCustomTokenError1", signInWithCustomTokenResult: JSON.stringify(result), error: JSON.stringify(error), phone: phone }).subscribe();
        }

      })
      .catch((error) => {
        this.firebaseLogger({ status: "signInWithCustomTokenError", phone: phone, error: JSON.stringify(error) }).subscribe();
      });
  }

  private setShoperId(shoperId: string) {
    var userJson = localStorage.getItem(AppConsts.currentCustomerKey);
    if (userJson) {
      var user: AuthUserInfo = JSON.parse(userJson);
      user.shoperId = shoperId;
      localStorage.setItem(AppConsts.currentCustomerKey, JSON.stringify(user));
      this.currentUserSubject.next(user);
    }
  }
  private setUserData(
    userFirebase,
    authToken: string,
    firebaseToken: string
  ) {
    const tmpUser: AuthUserInfo = {
      displayName: userFirebase.displayName || userFirebase.phoneNumber,
      authToken: authToken,
      firebaseToken: firebaseToken,
      uid: userFirebase.uid,
      phoneNumber: userFirebase.phoneNumber,
      shoperId: "",
    };
    localStorage.setItem(AppConsts.currentCustomerKey, JSON.stringify(tmpUser));
    this.currentUserSubject.next(tmpUser);
  }

  public setUnAuthUserData(userId: string) {
    const tmpUser: AuthUserInfo = {
      displayName: "",
      authToken: "",
      firebaseToken: "",
      uid: userId,
      phoneNumber: "",
      shoperId: "",
    };
    localStorage.setItem(AppConsts.currentCustomerKey, JSON.stringify(tmpUser));
    this.currentUserSubject.next(tmpUser);
  }

  private getDate() {
    var date = new Date();
    var res = "";
    res =
      date.getFullYear() +
      "/" +
      (date.getMonth() + 1) +
      "/" +
      date.getDate() +
      " " +
      date.getHours() +
      ":" +
      date.getMinutes() +
      ":" +
      date.getSeconds();
    return res;
  }

  private requestOTP(phone: string) {
    this.OTPInfo = new OTPInfo();
    this.OTPInfo.OtpRequestTime = this.getDate();
    this.smsLog = new SmsLog();
    this.smsLog.created = this.getDate();
    const postData = {
      phoneNumber: phone,
    };
    return this.apiService.post<OTPTransactionRequest>(
      Config.utopApiPath.requestOTP,
      postData,
      environment.apiQuatangunilever
    );
  }

  firebaseLogger(postData: any) {
    return this.apiService.post<any>(
      Config.utopApiPath.insightLogging,
      postData,
      environment.apiQuatangunilever
    );
  }

  logOTP(transactionId: string, type: string, phone: string) {
    localStorage.setItem(AppConsts.currentTransactionId, transactionId);
    const transsactionData = {
      transactionId: transactionId,
      type: type,
      parentId: 0,
      phone: phone,
    };
    this.apiService
      .post(
        Config.utopApiPath.otpLog,
        transsactionData,
        environment.dashboardApiHost
      )
      .toPromise();
  }

  public requestSmsLog(type: string) {
    try {
      this.smsLog.updated = this.getDate();
      this.smsLog.type = type;
      this.apiService
        .post(
          Config.utopApiPath.smsLog,
          this.smsLog,
          environment.unileverApiHost
        )
        .subscribe((res) => { });
    } catch (error) { }
  }

  private verifyOTP(phone: string, otpCode: string) {
    this.OTPInfo.Otp = otpCode;
    this.OTPInfo.OtpResponseTime = this.getDate();
    const postData = {
      phoneNumber: phone,
      otpCode: otpCode,
    };
    return this.apiService.post(
      Config.utopApiPath.verifyOTP,
      postData,
      environment.apiQuatangunilever
    );
  }

  private formatDate(d: string) {
    if (d) {
      var arr = d.split("/");
      return arr[2] + "/" + arr[1] + "/" + arr[0];
    }
    return "";
  }

  private requestLogin<RequestLogin>(uid: string, phone: string) {
    try {
      let postData = {};
      if (this.registerFormData) {
        postData = {
          loginProviderId: uid,
          type: "LoginFireBase",
          email: this.registerFormData.email,
          phoneNumber: this.registerFormData.phone,
          birthday: this.formatDate(this.registerFormData.birthday),
          name: this.registerFormData.fullname,
          gender: this.registerFormData.gender,
          ageRangeId: this.registerFormData.ageRangeId,
          otpInfo: this.OTPInfo,
        };
      } else {
        postData = {
          loginProviderId: uid,
          type: "LoginFireBase",
          phoneNumber: phone,
          otpInfo: this.OTPInfo,
        };
      }
      return this.apiService.post<RequestLogin>(
        Config.unileverApiPath.requestLogin,
        postData,
        environment.apiQuatangunilever
      );
    } catch (error) {
      window.UTopSDK.Tracking.logEvent(
        "tracking",
        { "errorRequestLogin1": error }
      );
    }

  }

  public loginWithQrCode(qrCode: string) {
    var req: QrCodeLoginRequest = new QrCodeLoginRequest();
    req.code = qrCode;
    return this.apiService.post<QrCodeLoginResponse>(
      Config.unileverApiPath.requestQrLogin,
      req,
      environment.unileverApiHost
    );
  }

  public loginWithQrCodeFlowSkip(qrCode: string) {
    var req: QrCodeLoginRequest = new QrCodeLoginRequest();
    req.code = qrCode;
    return this.apiService.post<QrCodeLoginResponse>(
      Config.unileverApiPath.requestQrLoginSkipUserInfo,
      req,
      environment.unileverApiHost
    );
  }

  public updateQrLoginRequest(data: QrCodeLoginResponse) {
    const tmpUser: AuthUserInfo = {
      displayName: data.phoneNumber,
      authToken: "",
      firebaseToken: "",
      uid: data.userId,
      phoneNumber: data.phoneNumber,
      shoperId: data.shortId,
    };
    localStorage.setItem(AppConsts.currentCustomerKey, JSON.stringify(tmpUser));
    this.currentUserSubject.next(tmpUser);
  }

  public getAgeRangeList() {
    return this.apiService.get<AgeRangeItem[]>(
      `${Config.unileverApiPath.getAgeRange}`,
      environment.apiQuatangunilever
    );
  }

  // public getShopTypeList() {
  //   return this.apiService.get<AgeRangeItem[]>(`${Config.unileverApiPath.getMasterByCode}?code=ShopType`, environment.apiQuatangunilever);
  // }

  // public getSkinCareList() {
  //   return this.apiService.get<AgeRangeItem[]>(`${Config.unileverApiPath.getMasterByCode}?code=SkinCare`, environment.apiQuatangunilever);
  // }

  public getUserInfo(userId: string) {
    return this.apiService.get<UserInfo>(
      `${Config.unileverApiPath.getUserInfo}?userId=${userId}`,
      environment.apiQuatangunilever
    );
  }

  public updateUserInfo(postData: any) {
    return this.apiService.post(
      `${Config.unileverApiPath.updateUserInfo}`,
      postData,
      environment.apiQuatangunilever
    );
  }

  getProvince<T>() {
    return this.apiService.get<T>(
      Config.unileverApiPath.getProvince,
      environment.unileverApiHost
    );
  }
  getQrlink(transactionId: string) {
    return this.apiService.get<QrInfoUser>(
      `${Config.unileverApiPath.qrlink}?transactionId=${transactionId}`,
      environment.apiQuatangunilever
    );
  }

  getDistrict(provinceId: string) {
    return this.apiService.get<MasterItem[]>(
      `${Config.unileverApiPath.getDistrict}?provinceId=${provinceId}`,
      environment.unileverApiHost
    );
  }
  getCommune(districtId: string) {
    return this.apiService.get<MasterItem[]>(
      `${Config.unileverApiPath.getCommune}?districtId=${districtId}`,
      environment.unileverApiHost
    );
  }
  reNewToken(postData: any) {
    return this.apiService.post<any>(
      `${Config.unileverApiPath.reNewToken}?key=${environment.firebase.apiKey}`,
      postData,
      environment.apiQuatangunilever
    );
  }
}
